import { Stack, Typography } from '@mui/material';
import CloseRounded from '@mui/icons-material/CloseRounded';
import { CloseButton } from './styles/DialogHeader.styles';
import { DialogHeaderProps } from './types';

const DialogHeader = ({ done, onClose }: DialogHeaderProps) => (
  <Stack
    direction="row"
    sx={{ alignItems: 'flex-start', gap: 1.5, p: '20px 24px 16px' }}
  >
    <Stack sx={{ gap: 0.4, flex: 1 }}>
      <Typography
        sx={{ fontSize: 17, fontWeight: 800, letterSpacing: '-.3px' }}
      >
        {done ? 'Purchase complete' : 'Add AI Credits'}
      </Typography>
      {!done && (
        <Typography sx={{ fontSize: 12.5, color: 'text.secondary' }}>
          Spend Credits from your vault to top up AI Credits.
        </Typography>
      )}
    </Stack>
    <CloseButton onClick={onClose} aria-label="Close">
      <CloseRounded sx={{ fontSize: 17 }} />
    </CloseButton>
  </Stack>
);

export default DialogHeader;
